import './player-home.css';
import { updateFunds } from '../services/funds.js';

const Key = {
  isLoading: 'home.isLoading',
  games: 'home.games',
};

export const PlayerHome = (props, { setState, getState, Auth, GameLink }) => {
  const startGame = async id => GameLink.startGame(id);

  return {
    hooks: {
      onMount: () => {
        Auth.fetch({ url: '/api/games' })
          .then(response => {
            setState(Key.games, response.games);
          })
          .catch(() => {});
      },
    },
    render: () => ({
      div: {
        className: 'h-screen',
        children: () => {
          const ui = [
            {
              TopBanner: {
                title: 'Web Games Testing Site',
                onAddFunds: () => {
                  Auth.fetch({
                    url: '/api/me/deposit',
                    method: 'POST',
                    body: { amount: 100 },
                  }).then(response => {
                    updateFunds(response.funds, { setState });
                  });
                },
                onRemoveFunds: () => {
                  if (!GameLink.isGameActive()) {
                    Auth.fetch({ url: '/api/me/withdraw', method: 'POST', body: {} }).then(
                      response => {
                        updateFunds(response.funds, { setState });
                      },
                    );
                  }
                },
                onLogout: () => {
                  if (!GameLink.isGameActive()) {
                    Auth.logout();
                  } else {
                    GameLink.exit();
                  }
                },
              },
            },
          ];
          if (!GameLink.isGameActive()) {
            ui.push({
              div: {
                style: { marginTop: '48px' },
                className:
                  'grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 p-4',
                children: () =>
                  getState(Key.games, []).map(game => ({
                    GameCell: {
                      name: game.title,
                      thumbnail: game.thumbnail
                        ? game.thumbnail.url
                        : `https://placehold.co/320x200?text=${game.external_id}`,
                      isLoading: () => getState(Key.isLoading) === game.id,
                      onClick: async () => {
                        if (getState(Key.isLoading, '') === '') {
                          try {
                            setState(Key.isLoading, game.id);
                            const error = await startGame(game.id);
                            if (error) {
                              alert(error);
                            }
                          } finally {
                            setState(Key.isLoading, '');
                          }
                        }
                      },
                    },
                  })),
              },
            });
          } else {
            const url = GameLink.gameUrl();
            ui.push({
              iframe: {
                style: { position: 'fixed', top: '40px', bottom: 0 },
                width: '100%',
                height: '100%',
                title: 'Game',
                className: 'game-iframe',
                src: url,
              },
            });
          }
          return ui;
        },
      },
    }),
  };
};
